import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const normalizePhone = (value) => value.replace(/[^\d+]/g, "");

const phoneValidation = (value) =>
  /^\+[1-9]\d{6,14}$/.test(normalizePhone(value));

const SigninWithPhone = (props) => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }

    if (!phoneValidation(userData.uid)) {
      setPhoneHasError(true);
      return;
    }

    setPhoneHasError(false);
    console.log("userData: ", userData);
    //post to server
    try {
      setLoading(true);
      const response = await axios.post("php/sign_in/signin.php", userData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);
      console.log("DATA MESSAGE", response.data);
      console.log("CALLNAME", response.data.callname);

      if (response.data.code !== 200) {
        if (response.data.code === 401) {
          alert(
            response.data?.message ||
              "Invalid credentials. Retry or use password help",
          );
        } else {
          alert(
            response.data?.message ||
              "Failed to sign in. Check your internet connection",
          );
        }
        return;
      }
      
      props.onLoggedIn({
        method: "email",
        callname: response.data.callname,
      });
    } catch (error) {
      const data = error?.response?.data;

      alert(
        data?.message ||
          "Invalid credentials or Error connecting to server. Please retry.",
      );
    } finally {
      setLoading(false);
    }
  };

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && phoneHasError) {
      setPhoneHasError(newValue ? !phoneValidation(newValue) : false);
    }
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Phone Number</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          type="tel"
          placeholder="Enter your phone number"
          maxLength={16}
          required
          autoComplete="tel"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
        {phoneHasError && (
          <span className={styles.errorText}>Your phone number is invalid</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onPhonePasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithPhone;
/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const normalizePhone = (value) => value.replace(/[^\d+]/g, "");

const validatePhone = (value) =>
  /^\+[1-9]\d{6,14}$/.test(normalizePhone(value));

const SigninWithPhone = (props) => {
  const [showSpinner, setShowSpinner] = useState();
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const [phoneHasError, setPhoneHasError] = useState();

  const [checked, setChecked] = useState(false);
  const checkboxType = (type) => {
    type === "password" ? (type = "text") : (type = "password");
    return type;
  };

  const checkboxChangeHandler = () => {
    const passwordInput = document.getElementById("password");
    setChecked(!checked);
    passwordInput.type = checkboxType(passwordInput.type);
  };

  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }
    if (!phoneValidation(userData.uid.trim())) {
      setPhoneHasError(true);
      return;
    } else setPhoneHasError(false);
    console.log("userData: ", userData);
    //post to server
    try {
      setShowSpinner(true);
      const response = await axios.post(
        "php/sign_in/signin.php",
        { ...userData, uid: userData.uid.slice(1) },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // Check the response
      console.log("response data: ", response.data);
      if (response.data == "Access denied" || response.data == 0) {
        alert(
          "Error connecting to server. Check your internet connection or retry later",
        );
      } else if (response.data == 1) {
        alert("Wrong phone number. Retry");
      } else if (response.data == 2) {
        alert("Wrong password. Retry");
      } else {
        props.onLoggedIn({
          method: "phone",
          callname: response.data,
        });
      }
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      alert(`Error: ${error} Please retry`);
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Phone Number</h2>
      </header>
      <div className={styles.inputView}>
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          placeholder="Enter your phone number"
          maxLength={15}
          required
          autoComplete="off"
          value={userData.uid}
          onChange={(e) =>
            setUserData({
              ...userData,
              uid: e.target.value.trim(),
            })
          }
        />
        {phoneHasError && (
          <span className={styles.errorText}>Your phone number is invalid</span>
        )}
      </div>
      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            type="password"
            id="password"
            placeholder="Enter your password"
            maxLength={15}
            required
            autoComplete="off"
            value={userData.password}
            onChange={(e) =>
              setUserData({
                ...userData,
                password: e.target.value.trim(),
              })
            }
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={checked}
            onChange={checkboxChangeHandler}
          />
        </div>
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
        >
          Submit
        </button>
        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onPhonePasswordHelpRequest}
        >
          Password help
        </button>
        <button className={styles.bgRed} onClick={props.onCancel}>
          Cancel
        </button>
      </div>
      {showSpinner && <Spinner />}
    </div>
  );
};

export default SigninWithPhone;
*/

/*
import SigninCredentialBase from "./SigninCredentialBase";

const normalizePhone = (value) => value.replace(/[^\d+]/g, "");

const validatePhone = (value) =>
  /^\+[1-9]\d{6,14}$/.test(normalizePhone(value));

const SigninWithPhone = (props) => {
  return (
    <SigninCredentialBase
      title="Sign in with your Phone Number"
      uidLabel="Phone Number"
      uidInputId="phone"
      uidInputType="tel"
      uidPlaceholder="Enter your phone number"
      uidMaxLength={16}
      uidAutoComplete="tel"
      method="phone"
      normalizeUid={normalizePhone}
      validateUid={validatePhone}
      invalidUidMessage="Your phone number is invalid"
      passwordHelpHandler={props.onPhonePasswordHelpRequest}
      onCancel={props.onCancel}
      onLoggedIn={props.onLoggedIn}
    />
  );
};

export default SigninWithPhone;

/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import { useAuthSubmit } from "../../../../auth/useAuthSubmit";

const normalizePhone = (value) => value.replace(/[^\d+]/g, "");

const phoneValidation = (value) =>
  /^\+[1-9]\d{6,14}$/.test(normalizePhone(value));

const SigninWithPhone = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const { submit, loading } = useAuthSubmit(
    "php/sign_in/signin.php",
    "phone",
    props.onLoggedIn,
  );

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && phoneHasError) {
      setPhoneHasError(newValue ? !phoneValidation(newValue) : false);
    }
  };

  const submitHandler = () => {
    if (loading) return;

    const uid = normalizePhone(userData.uid);
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill all fields correctly.");
      return;
    }

    if (!phoneValidation(uid)) {
      setPhoneHasError(true);
      return;
    }

    setPhoneHasError(false);

    submit({
      uid,
      password,
    });
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Phone Number</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          type="tel"
          placeholder="Enter your phone number"
          maxLength={16}
          required
          autoComplete="tel"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
        {phoneHasError && (
          <span className={styles.errorText}>Your phone number is invalid</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onPhonePasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithPhone;
/*

/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import { useAuthSubmit } from "../../../../auth/useAuthSubmit";

const normalizePhone = (value) => value.replace(/[^\d+]/g, "");

const phoneValidation = (value) =>
  /^\+[1-9]\d{8,16}$/.test(normalizePhone(value));

const SigninWithPhone = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const { submit, loading } = useAuthSubmit(
    "php/sign_in/signin.php",
    "phone",
    props.onLoggedIn,
  );

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && phoneHasError) {
      setPhoneHasError(newValue ? !phoneValidation(newValue) : false);
    }
  };

  const submitHandler = () => {
    if (loading) return;

    const uid = normalizePhone(userData.uid);
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill all fields correctly.");
      return;
    }

    if (!phoneValidation(uid)) {
      setPhoneHasError(true);
      return;
    }

    setPhoneHasError(false);

    submit({
      uid,
      password,
    });
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Phone Number</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          type="tel"
          placeholder="Enter your phone number"
          maxLength={16}
          required
          autoComplete="tel"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
        {phoneHasError && (
          <span className={styles.errorText}>Your phone number is invalid</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onPhonePasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithPhone;
*/
/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const normalizePhone = (value) => value.replace(/[^\d+]/g, "");

const phoneValidation = (value) =>
  /^\+[1-9]\d{6,14}$/.test(normalizePhone(value));

const SigninWithPhone = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && phoneHasError) {
      setPhoneHasError(newValue ? !phoneValidation(newValue) : false);
    }
  };

  const submitHandler = async () => {
    if (showSpinner) return;

    const uid = normalizePhone(userData.uid);
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill all fields correctly.");
      return;
    }    
    
    if (!phoneValidation(uid.trim())) {
      setPhoneHasError(true);
      return;
    } 
    
    setPhoneHasError(false);

    console.log(`uid: ${uid}; password: ${password}`);
    //post to server
    try {
      setShowSpinner(true);

      const res = await axios.post(
        "php/sign_in/signin.php",
        {
          uid,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );

      console.log("Server response:", res.data);

      if (res.data?.status !== "success") {
        throw new Error(res.data?.message || "Sign-in failed.");
      }

      props.onLoggedIn({
        method: "phone",
        callname: res.data.callname,
      });
    } catch (error) {
      console.error("Sign-in error:", error);

      const message =
        error.response?.data?.message ||
        error.message ||
        "Please retry or use another method.";

      alert(`Your sign-in credential failed. ${message}`);
    } finally {
      setShowSpinner(false);
    }
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Phone Number</h2>
      </header>
      <div className={styles.inputView}>
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          type="tel"
          placeholder="Enter your phone number"
          maxLength={16}
          required
          autoComplete="tel"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={showSpinner}
        />
        {phoneHasError && (
          <span className={styles.errorText}>Your phone number is invalid</span>
        )}
      </div>
      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={showSpinner}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={showSpinner}
        >
          Submit
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onPhonePasswordHelpRequest}
          disabled={showSpinner}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={showSpinner}
        >
          Cancel
        </button>
      </div>
      {showSpinner && <Spinner />}
    </div>
  );
  
};

export default SigninWithPhone;

*/
